import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { useRegisterQuestionsStore } from "../../store/useRegisterQuestionsStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

type ExtentedProps = {
  onSaveSuccess: () => void;              // ✅ callback to scroll
  
};
const Extented: React.FC<ExtentedProps> = ({ onSaveSuccess }) => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const { getRegisterQuestions, getQuestionByTitle } = useRegisterQuestionsStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);
  const [minage, setMinage] = useState(user?.looking_min_age || ""); // Store occupation text
  const [maxage, setMaxage] = useState(user?.looking_max_age || ""); // Store occupation text

  const Age: any = [];
  for (let index = 18; index <= 100; index++) {
      Age.push(index);
  }
  // Local state for controlled inputs
  const [selectedAnswers, setSelectedAnswers] = useState<{ [key: string]: string | number }>({});

  const [errors, setErrors] = useState<{ minage?: string;
      maxage?: string;
      zodiac?: string,
      politics?: string
      kids?: string; 
   
     
    }>({});

  useEffect(() => {
    getRegisterQuestions();
  }, [user]);

  // Initialize selectedAnswers from user.user_answers
useEffect(() => {
    if (user?.user_answers?.length > 0) {
      const initialAnswers: { [key: string]: string } = {};
      user.user_answers.forEach((answer: any) => {
        initialAnswers[answer.question_id] = answer.answer_id;
      });
      setSelectedAnswers(initialAnswers);
    }
  }, [user.user_answers]); // Run when user answers are fetched

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user, getUserDetails]);

  if (activeSection !== "extented") return null;

  // Function to validate form before submission
  const validateForm = () => {
    const newErrors: {
        minage?:string;
        maxage?:string;
        zodiac?: string; 
       
        politics?: string; 
        kids?: string; 
       
         
} = {
   
};

    if (!minage.trim()) newErrors.minage = "Minimum age is required.";
    if (!maxage.trim()) newErrors.maxage = "Maximum is required.";

    const zodiacQuestion = getQuestionByTitle("Horoscope");
    if (zodiacQuestion && !selectedAnswers[zodiacQuestion.id]) {
      newErrors.zodiac = "Zodiac status is required.";
    }

    const politicsQuestion = getQuestionByTitle("Politics");
    if (politicsQuestion && !selectedAnswers[politicsQuestion.id]) {
      newErrors.politics = "Politics status is required.";
    }

    const kidsQuestion = getQuestionByTitle("Kids_People");
    if (kidsQuestion && !selectedAnswers[kidsQuestion.id]) {
      newErrors.kids = "kids status is required.";
    }



   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Function to handle selection of marital status
  const selectOption = (questionId: number, answerId: number) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: answerId, // Store the selected answer for the question
    }));
  };

  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
        minage, // Include occupation in the update
        maxage,
     questions: Object.entries(selectedAnswers).map(([question_id, answer_id]) => ({
        question_id,
        answer_id,
      })),
    };

    try {
      await updateProfile(userId, updatedData);
      getUserDetails(userId);
  
      toast.success("Information updated successfully!");
      onSaveSuccess();
       setActiveSection(null); // Uncomment to close
    } catch (error) {
      console.log(error);
      
      toast.error("Failed to update Information. Please try again.");
    }
  };
  const zodiacQuestion = getQuestionByTitle("Horoscope");
  const zodiacQuestionId = zodiacQuestion?.id; // Store it once to avoid multiple calls

  const politicsQuestion = getQuestionByTitle("Politics");
  const politicsQuestionId = politicsQuestion?.id; // Store it once to avoid multiple calls

  const kidsQuestion = getQuestionByTitle("Kids_People");
  const kidsQuestionId=kidsQuestion?.id;

    const customStyles = {
  control: (base: any) => ({
    ...base,
    backgroundColor: 'transparent', // Bootstrap gray
    borderColor: '#888888',
    borderRadius: '50px',
    minHeight: '38px',
    boxShadow: 'none',
    color:'#1a202c'
  }),
  menu: (base: any) => ({
    ...base,
   // maxHeight: '150px',
    zIndex: 9999,
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 8px',
  }),
  dropdownIndicator: (base:any ) => ({
      ...base,
      padding: '8px',
      color:'#1a202c',
       svg: {
      width: 20,
      height: 20,
      strokeWidth: 0.1, // thinner icon
    },
  })
};
 const ageOptions = Array.from({ length: 82 }, (_, i) => {
  const val = i + 18;
  return { value: val, label: val.toString() };
});

  return (
    <div className="card border mb-3 filter-container">
      <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
        <h4 className="mb-0">Extended Profile</h4>
        <button 
          type="button"
          onClick={() => setActiveSection(null)}
          className="btn_close_cross_btn ms-auto"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      
      <div className="accordion" id="accordionExtendedProfile">
        {/* Zodiac */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.zodiac ? '' : ''}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#zodiacCollapse" aria-expanded="true" aria-controls="zodiacCollapse">
              Zodiac
            </button>
          </h2>
          <div id="zodiacCollapse" className={`accordion-collapse collapse ${errors.zodiac ? 'show' : 'show'}`}>
            <div className="accordion-body">
              {zodiacQuestion?.questions_options.map((option) => {
                const isChecked =
                  zodiacQuestionId &&
                  (selectedAnswers[zodiacQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) === zodiacQuestionId && Number(answer.answer_id) === option.id
                   ));
  
                return (
                  <div key={option.id} className="d-flex justify-content-between align-items-center mb-2">
                    <label htmlFor={`zodiac-${option.id}`} className="mb-0">
                      {option.option}
                    </label>
                    <input
                      type="radio"
                      id={`zodiac-${option.id}`}
                      name="zodiac"
                      defaultChecked={isChecked}
                      onChange={() => selectOption(option.question_id, option.id)}
                      className="form-check-input ms-2"
                    />
                  </div>
                );
              })}
              {errors.zodiac && <p className="text-red-500 text-sm">{errors.zodiac}</p>}
            </div>
          </div>
        </div>
  
        {/* Looking Match Age Between */}
        <div className="accordion-item mb-3">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.maxage ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#matchAgeCollapse" aria-expanded="false" aria-controls="matchAgeCollapse">
              Looking Match Age Between
            </button>
          </h2>
          <div id="matchAgeCollapse" className={`accordion-collapse collapse ${errors.maxage ? 'show' : ''}`}>
            <div className="accordion-body">
              <div className="form-group">
                <label className="form-label w-100 mb-3">What's my ideal age range for a match?</label>
                <div className="row g-3">
                  <div className="col-sm-4 col-6 col-md-3">
                    <Select
                                    components={{ IndicatorSeparator: () => null }} // This removes the |
                                      classNamePrefix="react-select"
                                      placeholder="From"
                                      value={ageOptions.find(opt => opt.value === Number(minage)) || null}
                                      options={ageOptions}
                                      styles={customStyles}
                                      onChange={(selectedOption) =>
                                        setMinage(selectedOption?.value.toString() || '')
                                      }
                                    />
                    
                    {errors.minage && <p className="text-red-500 text-sm">{errors.minage}</p>}
                  </div>
                  <div className="col-sm-4 col-6 col-md-3">
                     <Select
                                    components={{ IndicatorSeparator: () => null }} // This removes the |
                                      classNamePrefix="react-select"
                                      placeholder="To"
                                      value={ageOptions.find(opt => opt.value === Number(maxage)) || null}
                                      options={ageOptions}
                                      styles={customStyles}
                                      onChange={(selectedOption) =>
                                        setMaxage(selectedOption?.value.toString() || '')
                                      }
                                    />
                   
                    {errors.maxage && <p className="text-red-500 text-sm">{errors.maxage}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        {/* Political Affiliation */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.politics ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#politicsCollapse" aria-expanded="false" aria-controls="politicsCollapse">
              Political Affiliation
            </button>
          </h2>
          <div id="politicsCollapse" className={`accordion-collapse collapse ${errors.politics ? 'show' : ''}`}>
            <div className="accordion-body">
              {politicsQuestion?.questions_options.map((option) => {
                const isCheckedPolitics =
                  politicsQuestionId &&
                  (selectedAnswers[politicsQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) == Number(politicsQuestionId) && Number(answer.answer_id) == Number(option.id)
                   ));
  
                return (
                  <div key={option.id} className="d-flex justify-content-between align-items-center mb-2">
                    <label htmlFor={`politics-${option.id}`} className="mb-0">
                      {option.option}
                    </label>
                    <input
                      type="radio"
                      id={`politics-${option.id}`}
                      name="politics"
                      defaultChecked={isCheckedPolitics}
                      onChange={() => selectOption(option.question_id, option.id)}
                      className="form-check-input ms-2"
                    />
                  </div>
                );
              })}
              {errors.politics && <p className="text-red-500 text-sm">{errors.politics}</p>}
            </div>
          </div>
        </div>
  
        {/* Dating Someone With Kids */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className={`accordion-button ${errors.kids ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
              data-bs-target="#kidsMatchCollapse" aria-expanded="false" aria-controls="kidsMatchCollapse">
              Dating Someone With Kids
            </button>
          </h2>
          <div id="kidsMatchCollapse" className={`accordion-collapse collapse ${errors.kids ? 'show' : ''}`}>
            <div className="accordion-body">
              {kidsQuestion?.questions_options.map((option) => {
                const isCheckedKids =
                  kidsQuestionId &&
                  (selectedAnswers[kidsQuestionId] == option.id ||
                   user.user_answers.some(
                     (answer: any) => Number(answer.question_id) == kidsQuestionId && Number(answer.answer_id) == option.id
                   ));
  
                return (
                  <div key={option.id} className="d-flex justify-content-between align-items-center mb-2">
                    <label htmlFor={`kids-${option.id}`} className="mb-0">
                      {option.option}
                    </label>
                    <input
                      type="radio"
                      id={`kids-${option.id}`}
                      name="kidsMatch"
                      defaultChecked={isCheckedKids}
                      onChange={() => selectOption(option.question_id, option.id)}
                      className="form-check-input ms-2"
                    />
                  </div>
                );
              })}
              {errors.kids && <p className="text-red-500 text-sm">{errors.kids}</p>}
            </div>
          </div>
        </div>
      </div>
  
      <button
        onClick={handleSave}
        className="btn btn-outline-primary w-100 mt-3"
      >
        Save Changes
      </button>
    </div>
  );
};

export default Extented;
